@use '../../styling/colors.scss' as *;
@use '../../styling/typography.scss' as *;

.RunTypeBadge {
  @extend %font-family-primary;

  font-size: $font-size-normal;
  font-weight: $font-weight-semibold;
  background: $theme-run-type-badge-background-color;
  color: $theme-color-text;
  padding: 4px 6px;
  border: 1px $theme-run-type-badge-background-color solid;
  border-radius: 6px;
  justify-content: flex-start;
  align-items: center;
  display: inline-flex;
  line-height: 18px;
}
